import { UserDataFragment } from "@bonliva-crm/graphql";

type MappedOption = Array<{
  label: string;
  options: Array<{ label: string; value: UserDataFragment }>;
}>;

export function createGroupedUserOptions(users: UserDataFragment[]): MappedOption {
  const userOptions: Array<{
    label: string;
    options: Array<{ label: string; value: UserDataFragment }>;
  }> = [];

  users.forEach((user) => {
    if (user.Deleted || !user.Enabled) return;
    user.Teams.forEach((team) => {
      const curr = userOptions.find((option) => option.label === team);
      if (curr) {
        curr.options.push({
          label: user.Name,
          value: user
        });
      } else {
        userOptions.push({
          label: team,
          options: [{ label: user.Name, value: user }]
        });
      }
    });
  });

  return userOptions;
}
